
import http from "../../axios-config/g-http-metodos";

function getEnumDescricaoMaterial(){
    const{res,erro,requisicao} = http.get('OrcamentoComponente/GetEnumDescricaoMaterial')
    return {MaterialArray: res, erro , requisicao}
}

function getEnumDescricaoSistema(){
    const{res , erro, requisicao} = http.get('OrcamentoComponente/GetEnumDescricaoSistema')
    return {SistemaArray: res, erro , requisicao}
}

function getEnumEnumDescricaoMedida(){
    const{res , erro , requisicao} = http.get('OrcamentoComponente/GetEnumDescricaoMedida')
    return {MedidaConformeArray: res , erro , requisicao}
}



const OrcamentoComponenteController={
    getEnumDescricaoMaterial,
    getEnumDescricaoSistema,
    getEnumEnumDescricaoMedida,
}

export default OrcamentoComponenteController